import { RotateCcw } from "lucide-react";
import { Button } from "./ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

interface ResetButtonProps {
  onClick: () => void;
}

export function ResetButton({
  onClick
}: ResetButtonProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            className="h-8 w-8 p-0 flex-none"
            onClick={() => onClick()}
          >
            <span className="sr-only">Reset</span>
            <RotateCcw className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Reset</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
